import React from 'react';

const Navbar = () => {
	return (
        <nav className="bg-light">
		    <div className="container p-4">
                <div className="row">
                    <div className="col-12 text-center">
		    	        <h1>Welcome to the Cool Social Network 😎</h1>
                    </div>
                </div>
		    </div>
        </nav>
	);
};

export default Navbar